import { render, staticRenderFns } from "./alive.vue?vue&type=template&id=5696c830&scoped=true&"
import script from "./alive.vue?vue&type=script&lang=js&"
export * from "./alive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696c830",
  null
  
)

export default component.exports